import { createFileRoute } from '@tanstack/react-router';
import { isPermissionFull } from '@/features/login/util/permission';
import { validateRoute } from '@/router/util';

export const Route = createFileRoute('/a/cobranca-boleto')({
    beforeLoad: () =>
        validateRoute({
            fintech: true,
            validatePermission: ({ upp_financeiro_boleto }) =>
                isPermissionFull(upp_financeiro_boleto),
        }),
});
